module.exports = __webpack_public_path__ + "r-v3/img/plus.4ffb97b2.svg";